import { faTags } from '@fortawesome/pro-light-svg-icons';
import { faUser } from '@fortawesome/pro-regular-svg-icons';
import React, { FCC } from 'react';
import { Icon } from '../Icon';
import './Tags.scss';
import { ITagsProps } from './types';

export const Tags: FCC<ITagsProps> = (props) => {
  return (
    <ul qa-id={props['qa-id']} className="hlc-tags-container">
      <div>
        <Icon icon={faTags} className="hlc-tags-icon" />
        <div className="inside-tags-container">
          {props.tags.map((tag) => (
            <li key={tag.tag} className={'hlc-tag' + (tag.isTopic ? ' topic-tag' : '')}>
              <a href={tag.href} target="_blank">
                {tag.isUser ? <Icon icon={faUser} className="user-tag-icon" /> : null}
                {shortenText(tag.tag, 25)}
              </a>
            </li>
          ))}
        </div>
      </div>
    </ul>
  );
};

function shortenText(input: string, length: number) {
  const trimmedInput = input.trim();
  let end = trimmedInput.length;

  length -= 3;

  // If hard length limit, find last space before the limit is reached
  if (end > length) {
    end = trimmedInput.substr(0, length).lastIndexOf(' ');
  }

  if (end > 0 && end < trimmedInput.length) {
    return <span>{trimmedInput.substr(0, end)}&hellip;</span>;
  }

  // If no space before reaching hard limit, cut the word short and stick ellipsis on the end.
  if (end < 0 && trimmedInput.length > length) {
    return <span>{trimmedInput.substr(0, length)}&hellip;</span>;
  }

  return trimmedInput;
}

export default Tags;
